var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxLightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.589,
    height: 18.591,
    viewBox: "0 0 18.589 18.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M8.368,14.978H3.657a.311.311,0,1,0,0,.622h4.71a.311.311,0,0,0,0-.623Zm3.593-8.41L13.621,8.4l1.661-1.828h-.359a.312.312,0,0,1-.313-.312V3.964H12.632V6.256a.313.313,0,0,1-.313.312ZM7.083,10.522,13.2,14.051l-1.039,1.8L6.044,12.321l1.039-1.8Zm.51-.425,4.415-2.549L13.391,9.07a.312.312,0,0,0,.461,0l1.384-1.523L19.65,10.1l-6.029,3.481L7.593,10.1Zm6.341,5v5.977l6.027-3.48V13.754l-4.834,2.791a.311.311,0,0,1-.425-.115l-.768-1.33Zm6.226-4.578-6.113,3.53,1.039,1.8L21.2,12.321l-1.038-1.8ZM7.751,16.307a.311.311,0,1,1,0,.623H7.282V17.6l6.027,3.48V15.1l-.768,1.33a.311.311,0,0,1-.425.115L7.282,13.753v.536a.312.312,0,0,1-.625,0v-.9L5.464,12.7a.311.311,0,0,1-.115-.425L6.7,9.941a.372.372,0,0,1,.114-.114h0l4.765-2.751-.554-.61a.312.312,0,0,1,.23-.522h.753V3.651a.312.312,0,0,1,.312-.312h2.6a.313.313,0,0,1,.312.313V5.943h.752a.312.312,0,0,1,.219.536l-.542.6,4.748,2.741a.3.3,0,0,1,.14.14l1.341,2.322a.311.311,0,0,1-.115.425l-1.192.689v4.384a.313.313,0,0,1-.176.281L13.8,21.877a.31.31,0,0,1-.35,0l-6.633-3.83a.312.312,0,0,1-.155-.27V16.93h-1.7a.311.311,0,1,1,0-.623Z",
    transform: "translate(-3.346 -3.339)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxLightSm);
export default __webpack_public_path__ + "static/media/box-light-sm.adabdce0d2a510d91e18ca2d9585cd72.svg";
export { ForwardRef as ReactComponent };